import {handleLayoutCreationResponse} from "@frontend/store/creative-studio/chat-function-handlers/create-template";
import { handleRedirectToPdpImages, handleRedirectToSellSheet } from "@frontend/store/creative-studio/chat-function-handlers/redirect-to-pdp-images";
import {handleRedirectToDesignGallery} from "@frontend/store/creative-studio/chat-function-handlers/redirect-to-design-gallery";
import {handleCreateCampaign} from "@frontend/store/creative-studio/chat-function-handlers/create-campaign";
import {handleGenerateDesignConcept} from "@frontend/store/creative-studio/chat-function-handlers/generate-design-concept";
import {handleBrowseTemplates} from "@frontend/store/creative-studio/chat-function-handlers/browse-templates";
import {handleDownloadLastImage} from "@frontend/store/creative-studio/chat-function-handlers/download-last-image";
import {handleCreatePdpImageSet} from "@frontend/store/creative-studio/chat-function-handlers/create-pdp-image-set";
import {handleAddPdpImageTypes} from "@frontend/store/creative-studio/chat-function-handlers/add-pdp-image-types";
import {handleRedirectToFileBrowser, handleRedirectToFileBrowserProducts} from "@frontend/store/creative-studio/chat-function-handlers/redirect-to-browser";
import { handleSelectFolderModal } from "@frontend/store/creative-studio/chat-function-handlers/upload-files-to-browser";
import {handleCreateFolder} from "@frontend/store/creative-studio/chat-function-handlers/create-folder";
import { handleImportPsd } from "@frontend/store/creative-studio/chat-function-handlers/import-psd";
import { handleImportBannerImage } from "@frontend/store/creative-studio/chat-function-handlers/import-banner-image";
import { handleTranslateImage } from "@frontend/store/creative-studio/chat-function-handlers/translate-image";
import { handlePlaceProductOnBackground } from "@frontend/store/creative-studio/chat-function-handlers/place-product-on-background";
import { handleEditImage } from "@frontend/store/creative-studio/chat-function-handlers/edit-image";
import { handleSplitImageIntoLayers } from "@frontend/store/creative-studio/chat-function-handlers/split-image-into-layers";
import { handleGenerateAbHeroTest } from "@frontend/store/creative-studio/chat-function-handlers/generate-ab-hero-test";
import { handleCreatePdpLayoutWithProof } from "@frontend/store/creative-studio/chat-function-handlers/create-pdp-layout-with-proof";

export const CHAT_FUNCTION_HANDLERS = {
  'create_template': handleLayoutCreationResponse,
  'redirect_to_pdp_images': handleRedirectToPdpImages,
  'redirect_to_design_gallery': handleRedirectToDesignGallery,
  'create_campaign': handleCreateCampaign,
  'generate_design_concept': handleGenerateDesignConcept,
  'browse_templates': handleBrowseTemplates,
  'download_last_image': handleDownloadLastImage,
  'create_pdp_image_set': handleCreatePdpImageSet,
  'add_pdp_image_types': handleAddPdpImageTypes,
  'create_folder': handleCreateFolder,
  'open_sell_sheet': handleRedirectToSellSheet,
  'open_file_browser_files': handleRedirectToFileBrowser,
  'open_file_browser_products': handleRedirectToFileBrowserProducts,
  'upload_chat_attachments_to_folder': handleSelectFolderModal,
  'import_psd': handleImportPsd,
  'import_banner_image': handleImportBannerImage,
  'translate_image': handleTranslateImage,
  'place_product_on_background': handlePlaceProductOnBackground,
  'edit_image': handleEditImage,
  'split_image_into_layers': handleSplitImageIntoLayers,
  'generate_ab_hero_test': handleGenerateAbHeroTest,
  'create_pdp_layout_with_proof': handleCreatePdpLayoutWithProof,
}
